/* eslint-disable */
// prettier-ignore
import * as Types from '../../../../../../../graphql/__generated__';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FirmLinkageSummaryPartsFragment = {
  readonly __typename?: 'LinkageSummary';
  readonly linkFrequency: number;
  readonly uniqueBankCount: number;
  readonly bankRelationships: ReadonlyArray<{
    readonly __typename?: 'BankRelationship';
    readonly bankCmgEntityKey: string;
    readonly bankName: string;
    readonly linkedInvestorFirms: ReadonlyArray<{
      readonly __typename?: 'InvestorFirmsGrid';
      readonly firmKey?: string | null;
      readonly name: string;
    }>;
  }>;
};

export type Rolodex_FirmDetail_FirmLinkageSummaryQueryVariables = Types.Exact<{
  firmId: Types.Scalars['UUID']['input'];
}>;

export type Rolodex_FirmDetail_FirmLinkageSummaryQuery = {
  readonly __typename?: 'Query';
  readonly firms?: {
    readonly __typename?: 'FirmsCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'FirmFull';
      readonly id: string;
      readonly linkageSummary?: {
        readonly __typename?: 'LinkageSummary';
        readonly linkFrequency: number;
        readonly uniqueBankCount: number;
        readonly bankRelationships: ReadonlyArray<{
          readonly __typename?: 'BankRelationship';
          readonly bankCmgEntityKey: string;
          readonly bankName: string;
          readonly linkedInvestorFirms: ReadonlyArray<{
            readonly __typename?: 'InvestorFirmsGrid';
            readonly firmKey?: string | null;
            readonly name: string;
          }>;
        }>;
      } | null;
    }> | null;
  } | null;
};

export const FirmLinkageSummaryPartsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FirmLinkageSummaryParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'LinkageSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'linkFrequency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uniqueBankCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bankRelationships' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'bankCmgEntityKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bankName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'linkedInvestorFirms' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firmKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const Rolodex_FirmDetail_FirmLinkageSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Rolodex_FirmDetail_FirmLinkageSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firmId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'firms' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'firmId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linkageSummary' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'FirmLinkageSummaryParts' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FirmLinkageSummaryParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'LinkageSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'linkFrequency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uniqueBankCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bankRelationships' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'bankCmgEntityKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bankName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'linkedInvestorFirms' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firmKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useRolodex_FirmDetail_FirmLinkageSummaryQuery__
 *
 * To run a query within a React component, call `useRolodex_FirmDetail_FirmLinkageSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolodex_FirmDetail_FirmLinkageSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolodex_FirmDetail_FirmLinkageSummaryQuery({
 *   variables: {
 *      firmId: // value for 'firmId'
 *   },
 * });
 */
export function useRolodex_FirmDetail_FirmLinkageSummaryQuery(
  baseOptions: Apollo.QueryHookOptions<
    Rolodex_FirmDetail_FirmLinkageSummaryQuery,
    Rolodex_FirmDetail_FirmLinkageSummaryQueryVariables
  > &
    (
      | { variables: Rolodex_FirmDetail_FirmLinkageSummaryQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Rolodex_FirmDetail_FirmLinkageSummaryQuery,
    Rolodex_FirmDetail_FirmLinkageSummaryQueryVariables
  >(Rolodex_FirmDetail_FirmLinkageSummaryDocument, options);
}
export function useRolodex_FirmDetail_FirmLinkageSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Rolodex_FirmDetail_FirmLinkageSummaryQuery,
    Rolodex_FirmDetail_FirmLinkageSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Rolodex_FirmDetail_FirmLinkageSummaryQuery,
    Rolodex_FirmDetail_FirmLinkageSummaryQueryVariables
  >(Rolodex_FirmDetail_FirmLinkageSummaryDocument, options);
}
// @ts-ignore
export function useRolodex_FirmDetail_FirmLinkageSummarySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Rolodex_FirmDetail_FirmLinkageSummaryQuery,
    Rolodex_FirmDetail_FirmLinkageSummaryQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  Rolodex_FirmDetail_FirmLinkageSummaryQuery,
  Rolodex_FirmDetail_FirmLinkageSummaryQueryVariables
>;
export function useRolodex_FirmDetail_FirmLinkageSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Rolodex_FirmDetail_FirmLinkageSummaryQuery,
        Rolodex_FirmDetail_FirmLinkageSummaryQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  Rolodex_FirmDetail_FirmLinkageSummaryQuery | undefined,
  Rolodex_FirmDetail_FirmLinkageSummaryQueryVariables
>;
export function useRolodex_FirmDetail_FirmLinkageSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Rolodex_FirmDetail_FirmLinkageSummaryQuery,
        Rolodex_FirmDetail_FirmLinkageSummaryQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Rolodex_FirmDetail_FirmLinkageSummaryQuery,
    Rolodex_FirmDetail_FirmLinkageSummaryQueryVariables
  >(Rolodex_FirmDetail_FirmLinkageSummaryDocument, options);
}
export type Rolodex_FirmDetail_FirmLinkageSummaryQueryHookResult = ReturnType<
  typeof useRolodex_FirmDetail_FirmLinkageSummaryQuery
>;
export type Rolodex_FirmDetail_FirmLinkageSummaryLazyQueryHookResult = ReturnType<
  typeof useRolodex_FirmDetail_FirmLinkageSummaryLazyQuery
>;
export type Rolodex_FirmDetail_FirmLinkageSummarySuspenseQueryHookResult = ReturnType<
  typeof useRolodex_FirmDetail_FirmLinkageSummarySuspenseQuery
>;
export type Rolodex_FirmDetail_FirmLinkageSummaryQueryResult = Apollo.QueryResult<
  Rolodex_FirmDetail_FirmLinkageSummaryQuery,
  Rolodex_FirmDetail_FirmLinkageSummaryQueryVariables
>;
